var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 39.995L15 215.995",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 146L58 146C55.7909 146 54 149.582 54 154L54 190C54 194.418 55.7909 198 58 198L102 198C104.209 198 106 194.418 106 190L106 154C106 149.582 104.209 146 102 146Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58L58 58C55.7909 58 54 61.5817 54 66L54 102C54 106.418 55.7909 110 58 110L102 110C104.209 110 106 106.418 106 102L106 66C106 61.5817 104.209 58 102 58Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.111 146L152.889 146C151.293 146 150 149.582 150 154L150 190C150 194.418 151.293 198 152.889 198L199.111 198C200.707 198 202 194.418 202 190L202 154C202 149.582 200.707 146 199.111 146Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.111 58L152.889 58C151.293 58 150 61.5817 150 66L150 102C150 106.418 151.293 110 152.889 110L199.111 110C200.707 110 202 106.418 202 102L202 66C202 61.5817 200.707 58 199.111 58Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240 39.9951L240 215.995",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorSa);
export default __webpack_public_path__ + "static/media/hor-sa.d1cb5ca0df1fc90665f23cb720279a86.svg";
export { ForwardRef as ReactComponent };